import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { TelemedicineLookupResponse } from '../../responses/telemedicine/telemedicine-lookup.response';

@Injectable({
    providedIn: 'root'
})

export class TelemedicineLookupService extends CommonService {

    constructor(private router: Router, private httpClient: HttpClient,) {
        super();
    }

    public getLookup(): Observable<TelemedicineLookupResponse> {

        return this.httpClient.get<TelemedicineLookupResponse>(environment.urlApiTelemedicine + `Lookup`)
            .pipe(
                catchError(this.handleError)
            )
    }
}